/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nav_ApikeysInputs */

const en_common_nav_apikeys = /** @type {(inputs: Common_Nav_ApikeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Keys`)
};

const zh_common_nav_apikeys = /** @type {(inputs: Common_Nav_ApikeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 密钥`)
};

/**
* | output |
* | --- |
* | "API Keys" |
*
* @param {Common_Nav_ApikeysInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_nav_apikeys = /** @type {((inputs?: Common_Nav_ApikeysInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nav_ApikeysInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_nav_apikeys(inputs)
	return zh_common_nav_apikeys(inputs)
});
export { common_nav_apikeys as "common.nav.apikeys" }